var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from 'lodash';
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { AutoControlledComponent, childrenExist, createShorthandFactory, customPropTypes, commonPropTypes, } from '../../lib';
import MenuItem from './MenuItem';
import { menuBehavior } from '../../lib/accessibility';
/**
 * A menu displays grouped navigation actions.
 * @accessibility
 * Implements ARIA Menu, Toolbar or Tabs design pattern, depending on the behavior used.
 */
var Menu = /** @class */ (function (_super) {
    __extends(Menu, _super);
    function Menu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleItemOverrides = function (predefinedProps) { return ({
            onClick: function (e, itemProps) {
                var index = itemProps.index;
                _this.trySetState({ activeIndex: index });
                _.invoke(predefinedProps, 'onClick', e, itemProps);
            },
            onActiveChanged: function (e, props) {
                var index = props.index, active = props.active;
                if (active) {
                    _this.trySetState({ activeIndex: index });
                }
                else if (_this.state.activeIndex === index) {
                    _this.trySetState({ activeIndex: null });
                }
                _.invoke(predefinedProps, 'onActiveChanged', e, props);
            },
        }); };
        _this.renderItems = function (variables) {
            var _a = _this.props, iconOnly = _a.iconOnly, items = _a.items, pills = _a.pills, pointing = _a.pointing, primary = _a.primary, secondary = _a.secondary, underlined = _a.underlined, vertical = _a.vertical, submenu = _a.submenu;
            var activeIndex = _this.state.activeIndex;
            return _.map(items, function (item, index) {
                var active = (typeof activeIndex === 'string' ? parseInt(activeIndex, 10) : activeIndex) === index;
                return MenuItem.create(item, {
                    defaultProps: {
                        iconOnly: iconOnly,
                        pills: pills,
                        pointing: pointing,
                        primary: primary,
                        secondary: secondary,
                        underlined: underlined,
                        variables: variables,
                        vertical: vertical,
                        index: index,
                        active: active,
                        inSubmenu: submenu,
                    },
                    overrideProps: _this.handleItemOverrides,
                });
            });
        };
        return _this;
    }
    Menu.prototype.renderComponent = function (_a) {
        var ElementType = _a.ElementType, classes = _a.classes, accessibility = _a.accessibility, variables = _a.variables, rest = _a.rest;
        var children = this.props.children;
        return (React.createElement(ElementType, __assign({}, accessibility.attributes.root, rest, { className: classes.root }), childrenExist(children) ? children : this.renderItems(variables)));
    };
    Menu.displayName = 'Menu';
    Menu.className = 'ui-menu';
    Menu.propTypes = __assign({}, commonPropTypes.createCommon({
        content: false,
    }), { accessibility: PropTypes.func, activeIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]), defaultActiveIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]), fluid: PropTypes.bool, iconOnly: PropTypes.bool, items: customPropTypes.collectionShorthand, pills: PropTypes.bool, pointing: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['start', 'end'])]), primary: customPropTypes.every([customPropTypes.disallow(['secondary']), PropTypes.bool]), secondary: customPropTypes.every([customPropTypes.disallow(['primary']), PropTypes.bool]), underlined: PropTypes.bool, vertical: PropTypes.bool, submenu: PropTypes.bool });
    Menu.defaultProps = {
        as: 'ul',
        accessibility: menuBehavior,
    };
    Menu.autoControlledProps = ['activeIndex'];
    Menu.Item = MenuItem;
    return Menu;
}(AutoControlledComponent));
Menu.create = createShorthandFactory(Menu, 'items');
export default Menu;
